import React from 'react';
import { Container, Nav, NavDropdown, Navbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Printer, FileExcel, PlusCircleDotted, Search, CardChecklist } from 'react-bootstrap-icons';

import 'jspdf-autotable';
import 'assets/css/table.css';

function NavMenu({ printListe, setAdds, selected, exportCSV, setFacts, setShowFilterModals }) {
    return (
        <Navbar expand="lg" bg="light" variant="light">
            <Container>
                <Nav className="me-auto">
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-disabled">Faire une sortie de stock</Tooltip>}>
                        <Nav.Link href="#/admin/ventes" onClick={() => setAdds(1)} title="Faire une sortie de stock">
                            <PlusCircleDotted color="orange" size={25} /> Créer
                        </Nav.Link>
                    </OverlayTrigger>
                    <NavDropdown title="Exporter" id="basic-nav-dropdown">
                        <NavDropdown.Item href="#/admin/ventes" onClick={() => printListe()}>
                            <Printer color="#0080ff" size={20} />
                            Liste sortie par client (pdf)
                        </NavDropdown.Item>
                        <NavDropdown.Item href="#/admin/ventes" onClick={() => exportCSV()}>
                            <FileExcel color="green" size={20} />
                            Liste sortie par client (Excel)
                        </NavDropdown.Item>
                        {/* <NavDropdown.Item href="#/admin/ventes" onClick={() => setShowFilterModals(2)}>
                            <Printer color="#0080ff" size={20} />
                            Liste sortie par model (pdf)
                        </NavDropdown.Item> */}
                    </NavDropdown>
                    {Object.keys(JSON.parse(selected)).length > 0 ? (
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-disabled">Facturer des BLs</Tooltip>}>
                            <Nav.Link href="#/admin/ventes" onClick={() => setFacts(0)} title="Facturer des BLs">
                                <CardChecklist color="#0dd1fd" size={25} /> Facturer
                            </Nav.Link>
                        </OverlayTrigger>
                    ) : (
                        <></>
                    )}
                </Nav>
                <Nav>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-disabled">Recherche filtre</Tooltip>}>
                        <Nav.Link href="#/admin/ventes" onClick={() => setShowFilterModals(1)}>
                            <Search color="#0080ff" size={25} />
                        </Nav.Link>
                    </OverlayTrigger>
                </Nav>
            </Container>
        </Navbar>
    );
}
export default NavMenu;
